import usePlaidLink from 'hooks/usePlaidLink'
import React from 'react'
import { Button } from '@material-ui/core'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { integrateSupporterAccounts } from 'actions/supporters'
import { setBackdropLoading, setNotification } from 'actions/status'
import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

export default function PlaidButton({ includeWithdrawalAccount = false, children, ...rest }) {
  const dispatch = useDispatch()

  const userId = useCurrentUserProp('id')

  const handleSuccess = useCallback(async (token, metadata) => {
    // TODO: Use Loading button when next version of material ui comes out and when/if there
    // won't be a memory leak i.e. the button won't get removed from html upon completion
    dispatch(setBackdropLoading(true))
    const { institution: { institution_id: plaidInstitutionId }, account_id: plaidAccountIdForWithdrawalAccount } = metadata

    try {
      await dispatch(integrateSupporterAccounts(
        { userId, plaidPublicToken: token, plaidInstitutionId, plaidAccountIdForWithdrawalAccount }
      ))
    } catch {
      dispatch(setNotification('error', 'Something went wrong'))
    } finally {
      dispatch(setBackdropLoading(false))
    }
  }, [dispatch, userId])

  const { ready, open } = usePlaidLink({
    // TODO: change these customization names
    linkCustomizationName: includeWithdrawalAccount ? 'default' : 'for_roundup_accounts',
    onSuccess: handleSuccess
  })


  return (
    <Button { ...rest } disabled={!ready} onClick={() => open()}>
      {children}
    </Button>
  )
}
